import { CopilotConversationDTO } from './copilotConversationDTO';

// The Data of the EntityEvidenceAudit process row (ProcessStateEntityEvidenceAudit, PLAN-077). The client sends the
// conversation and, on a start, Force; the server fills the rest. The names follow the state Task 4 settles.
export class TenantProcessStateEntityEvidenceAuditDTO {
  entityType?: number;

  entityId?: number;

  entityName?: string;

  stage?: number;

  force?: boolean;

  consumerTaskId?: number;

  reportMarkdown?: string;

  appliedTaskId?: number;

  unchangedSince?: string;

  traceId?: string;

  conversation: CopilotConversationDTO;

  constructor() {
    this.conversation = new CopilotConversationDTO();
  }
}
